import { combineReducers } from "redux";

import { foldersConstants } from "../actions/folders";

function folders(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  let newState = [];
  switch (type) {
  case foldersConstants.GET_FOLDERS_SUCCESS:
    return payload._embedded ? payload._embedded.folders : [];
  case foldersConstants.DELETE_FOLDER_SUCCESS:
    if (defaultState) {
      defaultState.map((item) => {
        if (item.id !== payload.id) {
          return newState.push(item);
        }
        return null;
      });
    }
    return newState;
  case foldersConstants.CREATE_FOLDERS_SUCCESS:
    newState = defaultState;
    let checkId = false;
    if (defaultState) {
      defaultState.map((item) => {
        if (item.id === payload.id) {
          checkId = true;
        }
        return null;
      });
    }
    if (!checkId) {
      if (!newState) newState = []; // potrebbe essere null
      newState.push(payload);
    }
    return newState;
  case foldersConstants.UPDATE_FOLDER_SUCCESS:
    newState = [];
    // per bug sonar defaultState potrebbe essere null
    if (defaultState)
      defaultState.map((item) => {
        if (item.id === payload.id) {
          newState.push(payload);
        } else {
          newState.push(item);
        }
        return null;
      });

    return newState;
  default:
    return defaultState;
  }
}

function isGettingFolders(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.GET_FOLDERS_START:
    return true;
  case foldersConstants.GET_FOLDERS_SUCCESS:
  case foldersConstants.GET_FOLDERS_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingFolders(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.GET_FOLDERS_ERROR:
    return error ? error : true;
  case foldersConstants.GET_FOLDERS_START:
  case foldersConstants.GET_FOLDERS_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isSavingFolders(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.CREATE_FOLDERS_START:
  case foldersConstants.UPDATE_FOLDER_START:
    return true;
  case foldersConstants.CREATE_FOLDERS_SUCCESS:
  case foldersConstants.UPDATE_FOLDER_SUCCESS:
  case foldersConstants.CREATE_FOLDERS_ERROR:
  case foldersConstants.UPDATE_FOLDER_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorSavingFolders(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.CREATE_FOLDERS_ERROR:
    return error ? error : true;
  case foldersConstants.CREATE_FOLDERS_START:
  case foldersConstants.CREATE_FOLDERS_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isUpdatingFolder(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.UPDATE_FOLDER_START:
    return true;
  case foldersConstants.UPDATE_FOLDER_SUCCESS:
  case foldersConstants.UPDATE_FOLDER_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isUpdatingDocsFolder(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.UPDATE_DOCS_FOLDER_START:
    return true;
  case foldersConstants.UPDATE_DOCS_FOLDER_SUCCESS:
  case foldersConstants.UPDATE_DOCS_FOLDER_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorUpdatingFolder(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.UPDATE_FOLDER_ERROR:
    return error ? error : true;
  case foldersConstants.UPDATE_FOLDER_START:
  case foldersConstants.UPDATE_FOLDER_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isSendingEmail(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case foldersConstants.SEND_FOLDER_EMAIL_START:
    return true;
  case foldersConstants.SEND_FOLDER_EMAIL_SUCCESS:
  case foldersConstants.SEND_FOLDER_EMAIL_ERROR:
    return false;
  default:
    return defaultState;
  }
}

export const foldersReducer = combineReducers({
  folders,
  isGettingFolders,
  isErrorGettingFolders,
  isSavingFolders,
  isErrorSavingFolders,
  isUpdatingFolder,
  isErrorUpdatingFolder,
  isSendingEmail,
  isUpdatingDocsFolder
});

export default foldersReducer;
